import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=611059dd"
import script from "./DropdownDivider.vue?vue&type=script&lang=js"
export * from "./DropdownDivider.vue?vue&type=script&lang=js"
import style0 from "./DropdownDivider.vue?vue&type=style&index=0&id=611059dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DropdownDivider.vue?vue&type=custom&index=0&blockType=div&class=divider"
if (typeof block0 === 'function') block0(component)

export default component.exports